import { HowToWinBannerBig } from './components/HowToWinBannerBig';
import { HowToWinBannerSlim } from './components/HowToWinBannerSlim';
import type { HowToWinBannerVariant } from './hooks/useHowToWinBannerDisplay';

type HowToWinBannerProps = {
    onDismiss: () => void;
    showCloseButton: boolean;
    variant: HowToWinBannerVariant;
};

export const HowToWinBanner = ({ onDismiss, showCloseButton, variant }: HowToWinBannerProps) => {
    const isBig = variant === 'big';

    if (isBig) {
        return <HowToWinBannerBig />;
    }

    return (
        <HowToWinBannerSlim
            onDismiss={onDismiss}
            showCloseButton={showCloseButton}
        />
    );
};
